<script setup lang="ts">
const features = [
  ['媒体预检', '读取真实分辨率、帧率、编码、色彩与音轨信息，明确提示风险。'],
  ['三种画面适配', '支持裁剪填满、完整留白和模糊背景，手动调整构图与安全区域。'],
  ['多平台独立内容', '抖音、小红书、快手、视频号和 B 站分别保存封面与文案。'],
  ['处理队列与恢复', '逐平台执行，失败不会抹掉已完成结果，可单独重试和取消。'],
  ['输出复检', '完成后再次校验文件、时长、分辨率、编码、音视频轨道和清单。'],
  ['素材包导出', '每个平台独立目录，包含视频、封面、文案、发布清单和项目信息。'],
]
</script>

<template>
  <div class="page-wrap">
    <header class="page-heading">
      <h1>围绕发布前准备的核心能力</h1>
      <p>不登录平台、不自动发布，不把本地工具包装成全自动运营系统。</p>
    </header>
    <section class="feature-grid">
      <article v-for="([title, detail], index) in features" :key="title" class="ml-card">
        <span>{{ String(index + 1).padStart(2, '0') }}</span>
        <h2>{{ title }}</h2>
        <p>{{ detail }}</p>
      </article>
    </section>
    <section class="feature-boundary ml-card">
      <h2>明确边界</h2>
      <p>发多多不会采集平台账号、Cookie 或会话，不会模拟网页操作，不会承诺绕过平台规则。用户始终负责最终审核与发布。</p>
    </section>
  </div>
</template>

<style scoped>
.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.feature-grid article {
  min-height: 230px;
  padding: 28px;
}

.feature-grid span {
  color: var(--ml-brand);
  font-weight: 800;
}

.feature-grid h2 {
  margin: 36px 0 20px;
  font-size: 20px;
}

.feature-grid p,
.feature-boundary p {
  color: var(--ml-text-secondary);
  line-height: 1.9;
}

.feature-boundary {
  margin-top: 28px;
  padding: 30px;
  background: var(--ml-teal-soft);
}

@media (max-width: 820px) {
  .feature-grid {
    grid-template-columns: 1fr;
  }
}
</style>
